import React from "react";
import { SITE } from "../lib/data";
import { HouseHomeLogo } from "./AriakeLogo";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white pt-20 pb-10">
      <div className="container-hh grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10">
        <div className="col-span-12 md:col-span-5">
          <HouseHomeLogo variant="white" className="h-12 md:h-14" />
          <p className="mt-6 max-w-xs text-white/60 text-sm leading-relaxed">
            Inmobiliaria con 25 años construyendo hogares en Tumbaco y Pichincha.
            Respaldados por Constructora CVJ.
          </p>
          <div className="mt-8 flex gap-3">
            <a
              href={SITE.socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              data-testid="footer-instagram"
              aria-label="Instagram House & Home"
            >
              <Instagram size={16} />
            </a>
            <a
              href={SITE.socials.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              data-testid="footer-facebook"
              aria-label="Facebook House & Home"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline text-white/40 mb-5" style={{ fontSize: "0.65rem" }}>Navegación</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><a href="#nosotros" className="hover:text-white">Nosotros</a></li>
            <li><a href="#proyectos" className="hover:text-white">Proyectos</a></li>
            <li><a href="#ariake" className="hover:text-white">Ariake</a></li>
            <li><a href="#historial" className="hover:text-white">Trayectoria</a></li>
            <li><a href="#contacto" className="hover:text-white">Contacto</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <div className="overline text-white/40 mb-5" style={{ fontSize: "0.65rem" }}>Contacto</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3"><Phone size={14} className="mt-1 text-[hsl(var(--hh-sunrise))]" /><a href={`tel:${SITE.phoneIntl}`}>{SITE.phone}</a></li>
            <li className="flex gap-3"><Mail size={14} className="mt-1 text-[hsl(var(--hh-sunrise))]" /><a href={`mailto:${SITE.email}`} className="break-all">{SITE.email}</a></li>
            <li className="flex gap-3"><MapPin size={14} className="mt-1 text-[hsl(var(--hh-sunrise))]" /><span>Tumbaco · Pichincha, Ecuador</span></li>
          </ul>
        </div>
      </div>

      <div className="container-hh mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-white/40">
        <p>© {new Date().getFullYear()} Inmobiliaria House &amp; Home. Todos los derechos reservados.</p>
        <p>Respaldados por Constructora CVJ · Comercialización Savana</p>
      </div>
    </footer>
  );
}
